import React from "react";
import { FormGroup, Label } from "reactstrap";
import Switch from "react-switch";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "../field/formikfieldcustomprops";

const ReactSwitch: React.FC<FormikFieldCustomProps & FieldProps> = ({
  field: { name, value, onChange },
  form: { setFieldValue },
  ...props
}) => {
  const [checked, setChecked] = React.useState(!value);
  return (
    <FormGroup>
      <Label>{props.label}</Label>
      <br />
      {/* <pre>{JSON.stringify(props, null, 2)}</pre> */}
      <div className={`r-switch ${checked ? 'checked-bg' : 'unchecked-bg' }`}>
        <Switch
          {...props}
          height={47}
          width={95}
          handleDiameter={37}
          checked={checked}
          disabled={props.disabled || false}
          onChange={(value: any) => {
            setFieldValue(name, !value);
            setChecked(!checked)
          }}
          uncheckedIcon={
            <div className="switch-text off">
              <span>OFF</span>
            </div>
          }
          checkedIcon={
            <div className="switch-text on">
              <span>ON</span>
            </div>
          }
        />
      </div>
    </FormGroup>
  )
}

export default ReactSwitch;